export default function calculateScrollHeight() {
	if (typeof window !== 'undefined') {
		if (window.innerWidth > 768) {
			return '75px'
		} else {
			return '300px'
		}
	}
}
